module.exports = __webpack_public_path__ + "img/nu.bfd6de48.svg";